import React from 'react';
import WhenButtonGroup from '../Components/WhenButtonGroup';
import CreateTaskInput from '../Components/CreateTaskInput';
import ActionSelect from '../Components/ActionSelect';
import { SideBarSection } from '../StepSideBar/StepSideBar.styles';
import StaticProTip from '../Components/StaticProTip';
import AutomationTriggerFilters from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/AutomationTriggerFilters';

const TaskSideBar = () => {
    return (
        <>
            <SideBarSection>
                <ActionSelect />
            </SideBarSection>
            <SideBarSection>
                <CreateTaskInput />
            </SideBarSection>
            <SideBarSection>
                <WhenButtonGroup />
                <AutomationTriggerFilters />
                {/* Tasks always require approval 
                <ApprovalSwitcher /> */}
            </SideBarSection>
            <StaticProTip />
        </>
    );
};

export default TaskSideBar;
